import React, { useEffect, useState, useMemo, useRef } from 'react';
import AppConst from "../apis/appconst";
import axios from "axios";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import OrderTreatmentModal from '../models/OrderTreatmentModal';

const IpdPataintList = () => {


  const [showOrderTreatmentModal, setShowOrderTreatmentModal] = useState(false);
  const [orderTreatmentPatient, setOrderTreatmentPatient] = useState(null);


  const getUserType = () => {
    const stored = getStoredUser();
    if (!stored) return 'admin';
    const type = (stored.type || stored.user_type || '').toString().toLowerCase();
    if (type === 'doctor') return 'doctor';
    if (type === 'nurse') return 'nurse';
    const roleId = String(stored.role_id || stored.roleId || '');
    if (roleId === '3') return 'doctor';
    if (roleId === '4') return 'nurse';
    if (roleId === '1') return 'admin';
    return 'admin'; // default fallback
  };
   
  const openOrderModal = (row) => {
    setOrderTreatmentPatient(row);
    setShowOrderTreatmentModal(true);
  };

  const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null);
  // returns "YYYY-MM-DD"
const getLocalYYYYMMDD = (d = new Date()) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const filtersRef = useRef({ from: '', to: '', search_key: '' });

// ✅ Helper to attach logged-in user info to any FormData
const attachUserInfo = (fd) => {
  try {
    const stored = sessionStorage.getItem("ldata");
    if (stored) {
      const u = JSON.parse(stored);
      fd.append('user_id',   u.user_id   || '');
      fd.append('user_name', `${u.fname || ''} ${u.lname || ''}`.trim());
      fd.append('user_role', u.role_id   || u.role_name || '');
    }
  } catch (e) {
    console.warn("attachUserInfo failed:", e);
  }
  return fd;
};

const updateFilters = (updates) => {
  // ✅ Update state for UI
  setFormData(prev => ({ ...prev, ...updates }));
  
  // ✅ Only sync search_key to ref (dates stay empty so server always returns all)
  if (updates.search_key !== undefined) {
    filtersRef.current.search_key = updates.search_key;
  }
  // NOTE: We intentionally do NOT update filtersRef.current.from/to
  // because the server should always return ALL records,
  // and date filtering happens client-side in filteredList
};
  // --- read stored user safely from session/local storage
  const getStoredUser = () => {
    try {
      // prefer sessionStorage 'ldata' (your code uses it), then localStorage 'data' or 'ldata'
      const s = sessionStorage.getItem("ldata");
      if (s) {
        try { return JSON.parse(s); } catch (e) { /* fallthrough */ }
      }
      const other = localStorage.getItem("data") || localStorage.getItem("ldata") || sessionStorage.getItem("data");
      if (other) {
        try { return JSON.parse(other); } catch (e) { /* fallthrough */ }
      }
    } catch (err) {
      //console.warn("getStoredUser error:", err);
    }
    return null;
  };

// returns ["YYYY-MM-DD 00:00:00", "YYYY-MM-DD 23:59:59"] for the local date
const getLocalDayRange = (ymd) => {
  // ymd is "YYYY-MM-DD" or undefined => today
  const parts = (ymd || getLocalYYYYMMDD()).split('-').map(Number);
  const [y, m, d] = parts;
  // JS Date month index is 0-based
  const start = new Date(y, m - 1, d, 0, 0, 0);
  const end   = new Date(y, m - 1, d, 23, 59, 59);
  // format as server-friendly "YYYY-MM-DD HH:mm:ss"
  const fmt = (dt) => {
    const YYYY = dt.getFullYear();
    const MM = String(dt.getMonth() + 1).padStart(2, '0');
    const DD = String(dt.getDate()).padStart(2, '0');
    const hh = String(dt.getHours()).padStart(2, '0');
    const mm = String(dt.getMinutes()).padStart(2, '0');
    const ss = String(dt.getSeconds()).padStart(2, '0');
    return `${YYYY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
  };
  return [fmt(start), fmt(end)];
};


// put this inside the component that renders the IPD list (where `navigate` is available)
// Ensure `navigate` is available from react-router in this component








const handleBillingPrefill = async (row) => {
  if (!row) {
    return;
  }

  const uhid = row.ipd_uhid || row.ipd_bill_uhid || row.lab_reg_uhid || "";
  
  // Initialize all variables from ROW first (fallback values)
  let advanceAmount = Number(row.ipd_advance || row.advance || 0);
  let otDoctorId = row.ot_doctor || row.ipd_concult_doctor || row.ipd_ot_doctor || "";
  // ✅ NEW: Package due and package name from row
let pkgDueAmount = Number(row.ipd_pkg_due || row.package_due || row.pkg_due || 0);
let pkgNameValue = String(row.ipd_pkg_name || row.pkg_name || row.package_name || '').trim();
let pkgIdValue = String(row.ipd_pkg || row.pkg_id || '').trim();
  let asstDoctorId = row.ot_asst_doctor || row.ipd_asst_doctor || row.asst_doctor || "";
  let anesthesiaDoctorId = row.ot_anesthesia_doctor || row.ipd_anesthesia_doctor || row.anesthesia_doctor || "";
  let pediatricDoctorId = row.ot_pediatric_doctor || row.ot_Pediatric_doctor || row.ipd_pediatric_doctor || row.pediatric_doctor || "";
  let brokerId = row.ipd_broker_id || row.broker_id || "";
  let brokerName = row.ipd_broker_name || row.broker_name || "";
  let dischargeDatetime = row.discharge_datetime || row.ipd_discharge_datetime || "";
  let billDate = row.ipd_bill_date || "";   // ✅ ADD THIS
  // ✅ NEW: Bed details
  let bedId = row.ipd_bed || "";
  let bedName = row.ipd_bed_name || "";
  let bedPrice = Number(row.bed_price || 0);
  let wardId = row.ipd_ward || "";
  let wardName = row.ipd_ward_name || "";

  console.log("🔍 Initial row data:", {
    ot_doctor: row.ot_doctor,
    ot_asst_doctor: row.ot_asst_doctor,
    ot_anesthesia_doctor: row.ot_anesthesia_doctor,
    ot_pediatric_doctor: row.ot_pediatric_doctor,
    ipd_bed: row.ipd_bed,
    bed_price: row.bed_price
  });

  // Fetch from API to get complete data
  if (uhid) {
    try {
      const fd = new FormData();
      fd.append('ipd_uhid', uhid);
      const advResp = await axios.post(AppConst.BASE_URL + AppConst.getIpdBillByIdUrl, fd);
      
      console.log("🔍 API Response:", advResp?.data);
      
      if (advResp?.data?.status) {
        const billData = advResp.data.dt || {};
        const ipdData = advResp.data.ipd_dt || {};
        const directData = advResp.data || {};
        
        // Helper function to find value from multiple sources
        const findValue = (...sources) => {
          for (const source of sources) {
            if (source !== undefined && source !== null && source !== "") {
              return source;
            }
          }
          return "";
        };

        // Get advance
        advanceAmount = Number(findValue(
          directData.ipd_advance_from_ipd,
          billData.ipd_bill_adv_amount,
          billData.ipd_advance,
          ipdData.ipd_advance,
          ipdData.advance,
          advanceAmount
        )) || 0;
        
        // OT DOCTOR
        otDoctorId = findValue(
          billData.ipd_bill_concult_doctor,
          billData.ipd_concult_doctor,
          billData.ot_doctor,
          billData.ipd_ot_doctor,
          ipdData.ipd_concult_doctor,
          ipdData.ot_doctor,
          ipdData.ipd_ot_doctor,
          otDoctorId
        );
        
        // ASSISTANT DOCTOR
        asstDoctorId = findValue(
          billData.ot_asst_doctor,
          billData.ipd_asst_doctor,
          billData.ipd_bill_ot_asst_doctor,
          billData.asst_doctor,
          billData.ipd_bill_asst_doctor,
          ipdData.ot_asst_doctor,
          ipdData.ipd_asst_doctor,
          ipdData.asst_doctor,
          asstDoctorId
        );
        
        // ANESTHESIA DOCTOR
        anesthesiaDoctorId = findValue(
          billData.ot_anesthesia_doctor,
          billData.ipd_anesthesia_doctor,
          billData.ipd_bill_ot_anesthesia_doctor,
          billData.anesthesia_doctor,
          ipdData.ot_anesthesia_doctor,
          ipdData.ipd_anesthesia_doctor,
          ipdData.anesthesia_doctor,
          anesthesiaDoctorId
        );
        
        // PEDIATRIC DOCTOR
        pediatricDoctorId = findValue(
          billData.ot_pediatric_doctor,
          billData.ot_Pediatric_doctor,
          billData.ipd_pediatric_doctor,
          billData.ipd_bill_ot_pediatric_doctor,
          billData.pediatric_doctor,
          billData.ipd_bill_pediatric_doctor,
          ipdData.ot_pediatric_doctor,
          ipdData.ot_Pediatric_doctor,
          ipdData.ipd_pediatric_doctor,
          ipdData.pediatric_doctor,
          pediatricDoctorId
        );
        
        // ✅ BED DETAILS
        bedId = findValue(
          billData.ipd_bed,
          ipdData.ipd_bed,
          bedId
        );
        
        bedName = findValue(
          billData.ipd_bed_name,
          billData.bed_name,
          ipdData.ipd_bed_name,
          ipdData.bed_name,
          bedName
        );
        
        bedPrice = Number(findValue(
          billData.bed_price,
          ipdData.bed_price,
          bedPrice
        )) || 0;
        
        wardId = findValue(
          billData.ipd_ward,
          ipdData.ipd_ward,
          wardId
        );
        
        wardName = findValue(
          billData.ipd_ward_name,
          billData.ward_name,
          ipdData.ipd_ward_name,
          ipdData.ward_name,
          wardName
        );
        dischargeDatetime = findValue(
          directData.discharge_datetime,
          billData.discharge_datetime,
          ipdData.discharge_datetime,
          directData.ipd_discharge_datetime,
          billData.ipd_discharge_datetime,
          ipdData.ipd_discharge_datetime,
          dischargeDatetime
        );  

        billDate = findValue(          // ✅ ADD THIS BLOCK
          billData.ipd_bill_date,
          directData.ipd_bill_date,
          ipdData.ipd_bill_date,
          billDate
        );

// ✅ NEW: Package due
pkgDueAmount = Number(findValue(
  directData.ipd_pkg_due,
  billData.ipd_pkg_due,
  ipdData.ipd_pkg_due,
  pkgDueAmount
)) || 0;

// ✅ NEW: Package name
pkgNameValue = String(findValue(
  directData.ipd_pkg_name,
  billData.ipd_pkg_name,
  ipdData.ipd_pkg_name,
  pkgNameValue
) || '').trim();

// ✅ NEW: Package id
pkgIdValue = String(findValue(
  billData.ipd_pkg,
  ipdData.ipd_pkg,
  pkgIdValue
) || '').trim();

        // BROKER INFO
        brokerId = findValue(
          billData.ipd_broker_id,
          billData.broker_id,
          billData.ipd_bill_broker_id,
          ipdData.ipd_broker_id,
          ipdData.broker_id,
          brokerId
        );
        
        brokerName = findValue(
          billData.ipd_broker_name,
          billData.broker_name,
          billData.ipd_bill_broker_name,
          ipdData.ipd_broker_name,
          ipdData.broker_name,
          brokerName
        );
        
        console.log("✅ Values after API fetch:", {
          advance: advanceAmount,
          ot_doctor: otDoctorId,
          asst_doctor: asstDoctorId,
          anesthesia_doctor: anesthesiaDoctorId,
          pediatric_doctor: pediatricDoctorId,
          broker_id: brokerId,
          broker_name: brokerName,
          bed_id: bedId,
          bed_name: bedName,
          bed_price: bedPrice
        });
      }
    } catch (err) {
      console.warn("Could not fetch from IPD Bill API:", err);
    }
  }

  // ✅ COMPLETE PAYLOAD
  const payload = {
    // ========== PATIENT IDENTIFICATION ==========
    ipd_uhid: row.ipd_uhid || "",
    ipd_bill_uhid: row.ipd_bill_uhid || row.lab_reg_uhid || row.ipd_uhid || row.uhid || "",
    ipd_id: row.ipd_id || "",
    ipd_no: row.ipd_id || row.ipd_no || "",
    ipd_bill_id: row.ipd_bill_id || "",
    
    // ========== PATIENT DETAILS ==========
    ipd_patient_name: row.ipd_bill_patient_name || row.lab_reg_name || row.ipd_patient_name || row.name || "",
    ipd_bill_patient_name: row.ipd_bill_patient_name || row.lab_reg_name || row.ipd_patient_name || row.name || "",
    
    ipd_patient_phone: row.ipd_bill_patient_phone || row.ipd_patient_mobile || row.ipd_patient_phone || row.mobile || "",
    ipd_bill_patient_phone: row.ipd_bill_patient_phone || row.ipd_patient_mobile || row.ipd_patient_phone || row.mobile || "",
    
    ipd_patient_address: row.ipd_bill_patient_address || row.ipd_address || row.ipd_patient_address || row.address || "",
    ipd_bill_patient_address: row.ipd_bill_patient_address || row.ipd_address || row.ipd_patient_address || row.address || "",
    
    ipd_patient_age: row.ipd_bill_patient_age || row.ipd_age || row.age || "",
    ipd_bill_patient_age: row.ipd_bill_patient_age || row.ipd_age || row.age || "",
    
    ipd_patient_gender: row.ipd_bill_patient_gender || row.ipd_patient_gender || row.gender || "",
    ipd_bill_patient_gender: row.ipd_bill_patient_gender || row.ipd_patient_gender || row.gender || "",
    
    // ========== BED & WARD INFO (CRITICAL!) ==========
    ipd_bed: bedId,
    ipd_bill_bed: bedId,
    bed_name: bedName,
    ipd_bed_name: bedName,
    bed_price: bedPrice,
    
    ipd_ward: wardId,
    ipd_bill_ward: wardId,
    ward_name: wardName,
    ipd_ward_name: wardName,
    
    // ========== DATES ==========
    ipd_reg_date: row.ipd_bill_doa || row.ipd_reg_date || row.ipd_datetime || row.reg_date || "",
    ipd_bill_doa: row.ipd_bill_doa || row.ipd_reg_date || row.ipd_datetime || row.reg_date || "",
    ipd_datetime: row.ipd_datetime || row.ipd_reg_date || "",
    ipd_bill_date: billDate,
    

    // Discharge datetime (null if not yet discharged)
discharge_datetime: dischargeDatetime || "",
ipd_discharge_datetime: dischargeDatetime || "",
    // ========== DOCTORS (ALL VARIATIONS) ==========
    ipd_refer_doctor: row.ipd_refer_doctor || row.ipd_bill_refered_doctor || "",
    ipd_bill_refered_doctor: row.ipd_refer_doctor || row.ipd_bill_refered_doctor || "",
    
    // OT Doctor
    ot_doctor: otDoctorId,
    ipd_bill_concult_doctor: otDoctorId,
    ipd_concult_doctor: otDoctorId,
    ipd_ot_doctor: otDoctorId,
    
    // Assistant OT Doctor
    ot_asst_doctor: asstDoctorId,
    ipd_asst_doctor: asstDoctorId,
    ipd_bill_ot_asst_doctor: asstDoctorId,
    asst_doctor: asstDoctorId,
    
    // Anesthesia Doctor
    ot_anesthesia_doctor: anesthesiaDoctorId,
    ipd_anesthesia_doctor: anesthesiaDoctorId,
    ipd_bill_ot_anesthesia_doctor: anesthesiaDoctorId,
    anesthesia_doctor: anesthesiaDoctorId,
    
    // Pediatric Doctor
    ot_pediatric_doctor: pediatricDoctorId,
    ot_Pediatric_doctor: pediatricDoctorId,
    ipd_pediatric_doctor: pediatricDoctorId,
    ipd_bill_ot_pediatric_doctor: pediatricDoctorId,
    pediatric_doctor: pediatricDoctorId,
    
    // ========== FINANCIAL (CRITICAL!) ==========
    ipd_advance: advanceAmount,
    advance: advanceAmount,
    ipd_bill_adv_amount: advanceAmount,
    
    ipd_due: Number(row.ipd_due || 0),
    ipd_bill_due: Number(row.ipd_due || 0),
    
    // ✅ REGISTRATION CHARGES (IMPORTANT!)
    ipd_reg_charges: Number(row.ipd_reg_charges || 0),
    ipd_bill_reg_charges: Number(row.ipd_reg_charges || 0),
    


    // ✅ PACKAGE DUE & NAME
ipd_pkg_due: pkgDueAmount,
pkg_due: pkgDueAmount,
package_due: pkgDueAmount,
ipd_pkg_name: pkgNameValue,
pkg_name: pkgNameValue,
package_name: pkgNameValue,
ipd_pkg: pkgIdValue,
    // ========== BROKER/INSURANCE ==========
    ipd_broker_id: brokerId,
    broker_id: brokerId,
    ipd_bill_broker_id: brokerId,
    
    ipd_broker_name: brokerName,
    broker_name: brokerName,
    ipd_bill_broker_name: brokerName,
    
    ipd_policy_name: row.ipd_policy_name || "",
    ipd_bill_policy_name: row.ipd_policy_name || "",
    
    // ========== CASE ==========
    ipd_case: row.ipd_case || "",
    ipd_bill_case: row.ipd_case || "",
    
    // ========== ITEMS ==========
    otitems: [],
    
    // ========== FLAGS ==========
    force_load_existing: true,
    is_existing_patient: true,
    ipd_user: row.ipd_user || "1"
  };

  console.log("🔵 Final payload being saved to sessionStorage:", payload);

  try {
    sessionStorage.setItem('billing_prefill', JSON.stringify(payload));
    console.log("✅ Billing prefill data saved successfully");
  } catch (e) {
    console.warn('Could not set billing_prefill in sessionStorage', e);
    toast.error("Failed to save billing data");
    return;
  }

  navigate('/ipd_billing');
};
  const [showModal, setShowModal] = useState(false);
  const [headerLogo, setHeaderLogo] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();


  const [showAdvanceModal, setShowAdvanceModal] = useState(false);
const [selectedPatient, setSelectedPatient] = useState(null);
const [advanceForm, setAdvanceForm] = useState({ amount: '', payment_type: 'Cash', received_by: '' });
const [advanceHistory, setAdvanceHistory] = useState([]);
const [totalAdvance, setTotalAdvance] = useState(0);
const paymentTypes = ['Cash', 'Card', 'UPI', 'Bank Transfer', 'Cheque', 'Online'];

  const [formData, setFormData] = useState({
    l1: [],
    cats: [],
    docs: [],
    wards: [],
    beds: [],
    pkgs: [],
    case: [],
    page_no: 0,
    from: "",
    to: "",
    alertMsg: '',
    alertMsgTyp: '',
    search_key: '',
    isAlert: false,
  });


 


  const [totals, setTotals] = useState({
    totalAmount: 0,
    AdvanceAmount: 0,
    paidAmount: 0,
    PkgAmount: 0,
    totalRegCharges: 0
  });

  const [ldata, setLdata] = useState(null);
/* show the .view-btn only when its table row is hovered.
   DataTable uses .rdt_TableRow for rows — adjust if your version uses different class */
   const hoverStyle = `
   .view-btn { visibility: hidden; transition: visibility 0.05s ease-in-out, opacity 0.15s; opacity: 0; }
   .rdt_TableRow:hover .view-btn { visibility: visible; opacity: 1; }
   /* increase click area a little so it is easy to click when visible */
   .view-btn { pointer-events: auto; }
 `;


 const fmt = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  if (isNaN(dt)) return String(d);
  return dt.toLocaleString();
};

const openDetails = (row) => {
  if (!row) return;
  // find uhid (some rows may have moved-from-OPD uhid in different field)
  const uhid = row.ipd_uhid || row.opd_uhid_move || row.opd_uhid || '';

  // helper: safe parse into a local Date using your existing parser
  const safeParse = (s) => {
    if (!s) return null;
    try {
      // reuse your parseServerDateToLocal to avoid UTC shifts
      const dt = parseServerDateToLocal(s);
      if (dt) return dt;
      // fallback to plain Date
      const d = new Date(String(s).replace(' ', 'T'));
      return isNaN(d) ? null : d;
    } catch (e) {
      return null;
    }
  };

  // helper: format date+time (DD-MMM-YYYY HH:MM(:SS) ) - shows time only if present in source
  const formatDateTimeLocal = (raw, showSeconds = false) => {
    if (!raw) return '';
    // if original string contains time (HH:MM) show time; otherwise show date only
    const hasTime = /\b\d{1,2}:\d{2}(?::\d{2})?\b/.test(String(raw));
    const dt = safeParse(raw);
    if (!dt) return String(raw);
    const dd = String(dt.getDate()).padStart(2, '0');
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const month = months[dt.getMonth()];
    const yyyy = dt.getFullYear();
    const datePart = `${dd}-${month}-${yyyy}`;
    if (!hasTime) return datePart;
    const hh = String(dt.getHours()).padStart(2, '0');
    const mm = String(dt.getMinutes()).padStart(2, '0');
    const ss = String(dt.getSeconds()).padStart(2, '0');
    const timePart = showSeconds ? `${hh}:${mm}:${ss}` : `${hh}:${mm}`;
    return `${datePart} ${timePart}`;
  };

  // helper: compute age if dob present (returns "Xy Ym" or raw age field if given)
  const computeAgeDisplay = (r) => {
    // prefer explicit age fields (already formatted) if present
    if (r.ipd_patient_age) return r.ipd_patient_age;
    if (r.age) return r.age;
    // try DOB fields commonly used
    const dobCandidates = [r.ipd_dob, r.dob, r.patient_dob, r.ipd_patient_dob].filter(Boolean);
    if (dobCandidates.length) {
      const dob = safeParse(dobCandidates[0]);
      if (dob) {
        const now = new Date();
        let years = now.getFullYear() - dob.getFullYear();
        let months = now.getMonth() - dob.getMonth();
        let days = now.getDate() - dob.getDate();
        if (days < 0) { months -= 1; days += 30; }
        if (months < 0) { years -= 1; months += 12; }
        if (years < 0) return '';
        // return compact
        if (years > 0) return `${years}y ${months}m`;
        if (months > 0) return `${months}m ${days}d`;
        return `${days}d`;
      }
    }
    // fallback empty
    return '';
  };

  // --- compute the values to show ---
  const referredDoctor = row.ipd_refer_doctor_name || getDoctorNameById(row.ipd_refer_doctor, row) || '';
  const ageDisplay = row.ipd_age || row.age || '';
  // OT doctor could be stored in multiple fields, try common names
  const otDoctor = row.ot_doctor || getDoctorNameById(row.ot_doctor) || row.ipd_ot_doctor  || '';
  // OT date/time many possible fields: ot_reg_date, ot_datetime, ot_date, ot_sched_time, fallback to ipd_reg_date
  const otDateRaw = row.ot_reg_date || row.ot_datetime || row.ot_date || row.ot_sched_time || row.ipd_reg_date || row.ipd_datetime || '';
  const otDateFormatted = formatDateTimeLocal(otDateRaw, true);

  // prefer server-provided names, otherwise lookup in formData lists
  const wardName = row.ipd_ward_name || (formData.wards.find(w => String(w.cat_id) === String(row.ipd_ward))?.cat_name) || 'Ward N/A';
  const bedName  = row.ipd_bed_name  || (formData.beds.find(b => String(b.bed_id) === String(row.ipd_bed))?.bed_name)   || 'Bed N/A';

  // build main patient info HTML — inserted Referred Doctor, Age, OT Doctor and OT Date
  const mainHtml = `
    <style>
      .sa-bed-row { display:flex; gap:12px; align-items:center; margin-bottom:8px; }
      .sa-bed-card {
        display:flex;
        align-items:center;
        gap:10px;
        padding:10px 12px;
        border-radius:8px;
        box-shadow: 0 1px 4px rgba(0,0,0,0.08);
        background: #ffffff;
        border: 1px solid rgba(0,0,0,0.04);
        min-width: 160px;
      }
      .sa-bed-icon {
        width:36px;
        height:36px;
        border-radius:8px;
        display:flex;
        align-items:center;
        justify-content:center;
        background: linear-gradient(135deg,#eef7ff,#e6f4ff);
        font-size:18px;
        color:#0d6efd;
      }
      .sa-bed-meta { font-size:13px; line-height:1; }
      .sa-bed-meta .label { color:#6c757d; font-size:11px; display:block; }
      .sa-bed-meta .value { font-weight:700; font-size:13px; color:#24292f; }
      @media (max-width:480px) {
        .sa-bed-row { flex-direction:column; align-items:flex-start; }
      }
    </style>

    <div style="display:flex; justify-content:space-between; gap:18px; flex-wrap:wrap;">
      <div style="flex:1 1 320px;">
        <div style="font-size:14px; font-weight:700; color:#222; margin-bottom:6px;">Patient</div>
        <div style="font-size:13px; color:#333;">
          <b>UHID:</b> ${uhid || 'N/A'}<br/>
          <b>IPD No:</b> ${row.ipd_display_no || (row.ipd_id ? `000${row.ipd_id}` : (row.ipd_no || 'N/A'))}<br/>
          <b>Name:</b> ${row.ipd_patient_name || row.lab_reg_name || 'N/A'}<br/>
          <b>Phone:</b> ${row.ipd_patient_mobile || row.ipd_cont_number || 'N/A'}<br/>
          <b>Age:</b> ${ageDisplay || 'N/A'}<br/>
          <b>Referred Doctor:</b> ${referredDoctor || 'N/A'}<br/>
        </div>
      </div>

      <div style="display:flex; flex-direction:column; gap:8px; align-items:flex-end;">
        <div class="sa-bed-row">
          <div class="sa-bed-card" title="Ward">
            <div class="sa-bed-icon"><i class="bx bx-building" style="font-size:18px;"></i></div>
            <div class="sa-bed-meta">
              <span class="label">Ward</span>
              <span class="value">${wardName}</span>
            </div>
          </div>

          <div class="sa-bed-card" title="Bed">
            <div class="sa-bed-icon"><i class="bx bx-bed" style="font-size:18px;"></i></div>
            <div class="sa-bed-meta">
              <span class="label">Bed</span>
              <span class="value">${bedName}</span>
            </div>
          </div>
        </div>

        <div style="margin-top:6px; text-align:right;">
          <div style="font-size:13px; color:#333;">
            <b>OT Doctor:</b> ${row.ot_doctor_name || row.ot_doctor || 'N/A'}<br/>
            <b>OT Date:</b> ${formatDateTimeLocal(row.ot_datetime) || (row.ot_reg_date ? formatDateTimeLocal(row.ot_reg_date) : 'N/A')}<br/>
          </div>
        </div>
      </div>
    </div>
  `;

  // build visit history... (keep your existing historyHtml code unchanged)
  const allRecords = Array.isArray(formData.l1) ? formData.l1.slice() : [];
  const sameUhid = allRecords.filter(r => {
    const rUhid = r.ipd_uhid || r.opd_uhid_move || r.opd_uhid || r.lab_reg_uhid || '';
    return uhid && String(rUhid) === String(uhid);
  });

  sameUhid.sort((a,b) => {
    const getDate = (x) => new Date(x.ipd_reg_date || x.ipd_datetime || x.opd_datetime || x.reg_date || x.created_at || 0).getTime() || 0;
    return getDate(b) - getDate(a);
  });

  let historyHtml = '<div style="margin-top:10px; text-align:left;">';
  if (sameUhid.length === 0) {
    historyHtml += `<b>Visit History:</b> None found for this UHID.`;
  } else {
    historyHtml += `<b>Visit History (most recent first):</b><br/><table style="width:100%; border-collapse:collapse; margin-top:6px;">`;
    historyHtml += `<thead><tr>
      <th style="text-align:left; padding:6px; border-bottom:1px solid #ddd;">Date</th>
      <th style="text-align:left; padding:6px; border-bottom:1px solid #ddd;">Type</th>
      <th style="text-align:left; padding:6px; border-bottom:1px solid #ddd;">Notes</th>
    </tr></thead><tbody>`;
    sameUhid.forEach((r) => {
      const date = fmt(r.ipd_reg_date || r.ipd_datetime || r.opd_datetime || r.reg_date || r.created_at);
     // replace the old line with this mapped version
const type = (() => {
  const tRaw = r.ipd_type == null ? '' : String(r.ipd_type).trim();
  // map numeric/string codes to friendly labels — adjust to match your backend
  const typeMap = {
    '1': 'IPD',
    '2': 'OPD',
    '3': 'Lab',
    'emergency': 'Emergency',
    'routine': 'Routine'
  };
  if (tRaw) {
    // if mapped label exists return it, otherwise return the raw text (capitalized)
    return typeMap[tRaw.toLowerCase()] || (tRaw.charAt(0).toUpperCase() + tRaw.slice(1));
  }
  return r.ipd_id ? 'IPD' : (r.opd_id ? 'OPD' : (r.lab_reg_id ? 'Lab' : 'Record'));
})();

      const notes = (r.ipd_case || r.opd_type || r.ipd_remarks || r.opd_remark || '').toString().slice(0, 80);
      historyHtml += `<tr>
        <td style="padding:6px; border-bottom:1px solid #f1f1f1;">${date}</td>
        <td style="padding:6px; border-bottom:1px solid #f1f1f1;">${type}</td>
        <td style="padding:6px; border-bottom:1px solid #f1f1f1;">${notes || '-'}</td>
      </tr>`;
    });
    historyHtml += `</tbody></table>`;
  }
  historyHtml += '</div>';

  const content = `${mainHtml}${historyHtml}`;

  // show modal via SweetAlert2
  Swal.fire({
    title: `Patient Details`,
    html: content,
    width: 800,
    showCloseButton: true,
    focusConfirm: false,
    confirmButtonText: 'Close',
    didOpen: () => {
      // any post open tasks if needed
    }
  });
};

// Open modal & fetch history
// Open modal & fetch history
const openAdvanceModal = async (row) => {
  const storedUser = getStoredUser(); // Get logged user
  const userName = storedUser?.fname || storedUser?.name || storedUser?.user_name || storedUser?.username || '';
  
  setSelectedPatient(row);
  setAdvanceForm({ 
    amount: '', 
    payment_type: 'Cash', 
    received_by: userName  // Auto-fill logged user name
  });
  setShowAdvanceModal(true);
  
  // Fetch history
  const fd = new FormData();
  fd.append('action', 'get');
  fd.append('ipd_id', row.ipd_id);
  const res = await axios.post(AppConst.BASE_URL + AppConst.getIpdAdvancePaymentsUrl, fd);
  if (res.data.status) {
    setAdvanceHistory(res.data.records);
    setTotalAdvance(Number(res.data.total_advance) || 0);

  }
};

// Save advance
const saveAdvance = async () => {
  if (!advanceForm.amount) {
    toast.error("Enter advance amount");
    return;
  }

  const fd = new FormData();
  fd.append('ipd_id', selectedPatient.ipd_id);
  fd.append('ipd_uhid', selectedPatient.ipd_uhid);
  fd.append('advance_amount', advanceForm.amount);
  fd.append('payment_type', advanceForm.payment_type);
  fd.append('received_by', advanceForm.received_by);

  try {
    const res = await axios.post(
      AppConst.BASE_URL + AppConst.addIpdAdvanceUrl,
      fd
    );

    if (res.data.status) {
      toast.success("Advance added successfully");

      // ✅ Refresh advance history
      const fd2 = new FormData();
      fd2.append('action', 'get');
      fd2.append('ipd_id', selectedPatient.ipd_id);
      const histRes = await axios.post(AppConst.BASE_URL + AppConst.getIpdAdvancePaymentsUrl, fd2);
      if (histRes.data.status) {
        setAdvanceHistory(histRes.data.records);
        setTotalAdvance(Number(histRes.data.total_advance) || 0);
      }

      // ✅ Clear amount field
      setAdvanceForm(prev => ({ ...prev, amount: '' }));

      // ✅ Refresh list in background — no await so UI stays responsive
      initData();

    } else {
      toast.error(res.data.message || "Failed to add advance");
    }
  } catch (err) {
    console.error("saveAdvance error:", err);
    toast.error("Failed to add advance");
  }
};

const printSingleAdvanceReceipt = async (payment) => {
  if (!payment || !selectedPatient) return;

  const doc = new jsPDF("p", "pt", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 40;
  let y = 40;

  // ===== HEADER =====
  const headerImageBase64 = await imageUrlToBase64(headerLogo);
  if (headerImageBase64) {
    doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, 80);
    y = 95;
  }

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("ADVANCE PAYMENT RECEIPT", pageWidth / 2, y, { align: "center" });
  y += 25;

  doc.line(margin, y, pageWidth - margin, y);
  y += 15;

  // ===== PATIENT DETAILS =====
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  const leftX = margin;
  const rightX = pageWidth / 2 + 20;

  const row = (label, value, x, yPos) => {
    doc.text(label, x, yPos);
    doc.text(":", x + 100, yPos);
    doc.text(String(value || ""), x + 110, yPos);
  };

  row("UHID", selectedPatient.ipd_uhid, leftX, y);
  row("IPD No", selectedPatient.ipd_display_no || `000${selectedPatient.ipd_id}`, rightX, y);
  y += 14;

  row("Patient Name", selectedPatient.ipd_patient_name, leftX, y);
  row("Mobile", selectedPatient.ipd_patient_mobile, rightX, y);
  y += 14;

  row(
    "Ward / Bed",
    `${selectedPatient.ipd_ward_name || ""} / ${selectedPatient.ipd_bed_name || ""}`,
    leftX,
    y
  );
  row(
    "Admission Date",
    formatServerDateLocal(selectedPatient.ipd_reg_date),
    rightX,
    y
  );
  y += 25;

  // ===== PAYMENT DETAILS (SINGLE ROW) =====
  autoTable(doc, {
    startY: y,
    head: [["Date", "Payment Type", "Received By", "Amount"]],
    body: [[
      new Date(payment.payment_date).toLocaleString("en-IN"),
      payment.payment_type,
      payment.received_by,
      parseFloat(payment.advance_amount).toFixed(2)
    ]],
    theme: "grid",
    styles: {
      fontSize: 10,
      cellPadding: 6
    },
    headStyles: {
      fillColor: [240, 245, 251],
      textColor: 0,
      fontStyle: "bold"
    },
    columnStyles: {
      3: { halign: "right" }
    },
    margin: { left: margin, right: margin }
  });

  y = doc.lastAutoTable.finalY + 50;

  // ===== SIGNATURE =====
  doc.line(pageWidth - 200, y, pageWidth - margin, y);
  doc.text("Authorized Signature", pageWidth - margin, y + 20, { align: "right" });

  // ===== OPEN PDF =====
  window.open(doc.output("bloburl"), "_blank");
};


// Delete
const deleteAdvance = async (id) => {
  setShowAdvanceModal(false);

  const result = await Swal.fire({
    title: 'Delete Advance Payment?',
    text: 'This will reverse the advance payment. Are you sure?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel'
  });

  if (!result.isConfirmed) {
    setShowAdvanceModal(true);
    return;
  }

  try {
    const fd = new FormData();
    fd.append('advance_id', String(id));

    const res = await axios.post(
      AppConst.BASE_URL + AppConst.deleteIpdAdvanceUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    if (res.data && res.data.status) {
      toast.success(res.data.message || 'Advance payment deleted successfully');

      // ✅ Refresh advance history
      const fd2 = new FormData();
      fd2.append('action', 'get');
      fd2.append('ipd_id', selectedPatient.ipd_id);
      const histRes = await axios.post(AppConst.BASE_URL + AppConst.getIpdAdvancePaymentsUrl, fd2);
      if (histRes.data.status) {
        setAdvanceHistory(histRes.data.records);
        setTotalAdvance(Number(histRes.data.total_advance) || 0);
      }

      // ✅ Refresh list — no await
      initData();

      setShowAdvanceModal(true);
    } else {
      toast.error(res.data?.message || 'Failed to delete advance payment');
      setShowAdvanceModal(true);
    }
  } catch (error) {
    console.error('deleteAdvance error:', error);
    toast.error('Server error while deleting advance payment');
    setShowAdvanceModal(true);
  }
};

  // ---------- Data fetchers (updated to accept optional override dates) ----------
 const initData = async (overrides = {}) => {
  const storedUser = getStoredUser();
  if (storedUser) {
    const maybeIsAdmin =
      storedUser.is_admin === 1 ||
      storedUser.isAdmin === 1 ||
      storedUser.role === 'admin' ||
      storedUser.user_type === 'admin' ||
      storedUser.role_id === 1 || storedUser.role_id === "1" ||
      storedUser.user_role === 'admin';
    setIsAdmin(Boolean(maybeIsAdmin));
  } else {
    setIsAdmin(false);
  }

  // ✅ Use ref as reliable source, overrides take priority
  const currentFilters = filtersRef.current;
  const fromVal = overrides.from !== undefined ? overrides.from : currentFilters.from;
  const toVal = overrides.to !== undefined ? overrides.to : currentFilters.to;
  const searchKey = overrides.search_key !== undefined ? overrides.search_key : currentFilters.search_key;

  const fd = new FormData();
  fd.append('page_no', "none");
  fd.append('search_key', searchKey + "");
  if (fromVal) fd.append('from', fromVal);
  if (toVal) fd.append('to', toVal);
  fd.append('status', '0');

  try {
    const response = await axios.post(AppConst.BASE_URL + AppConst.getIpdListUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    console.log('initData response', response.data);
    if (response.data.status) {
      const records = response.data.records || [];
      // ✅ Only update l1, preserve ALL other fields
      setFormData(prev => ({ ...prev, l1: records }));
    } else {
      setFormData(prev => ({ ...prev, l1: [] }));
      console.warn('initData: server returned status false', response.data);
    }
  } catch (error) {
    console.error("initData error:", error);
    if (error?.response) {
      console.error('Server response body:', error.response.data);
    }
  }
};

  const initData1 = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (!storedData) return;
    const fd2 = new FormData();
    fd2.append('type', "doctor");
    fd2.append('search_key', "");
    fd2.append('page_no', "none");
    fd2.append('user_cre_by', 1 + "");
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response.data.status) {
        const records = response.data.records || [];
        setFormData(prev => ({ ...prev, docs: records }));
      }
    } catch (error) {
      console.error("initData1 error:", error);
    }
  };

  const initData3 = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (!storedData) return;
    try {
      let fd = new FormData();
      fd.append('page_no', "0");
      fd.append('search_key', formData.search_key + "");
      fd.append('test_user', "");
      const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response.data.status) {
        const records = response.data.records || [];
        setFormData(prev => ({ ...prev, tests: records }));
        if (!prevHasTests(prev => prev.tests1 && prev.tests1.length > 0)) {
          setFormData(prev => ({ ...prev, tests1: records }));
        }
      }
    } catch (error) {
      // ignore
    }

    const catFetch = async (cat_type, extra = {}) => {
      try {
        const fd0 = new FormData();
        fd0.append('cat_type', cat_type);
        fd0.append('page_no', "none");
        fd0.append('par_by', 1 + "");
        Object.entries(extra).forEach(([k, v]) => fd0.append(k, v));
        const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd0, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data.status ? response.data.records || [] : [];
      } catch (err) { return []; }
    };

    try {
      const cats = await catFetch("speciality");
      const wards = await catFetch("ward");
      const pkgs = await catFetch("package");
      const hospCharges = await catFetch("hospCharge", { cat_name: "Registration Fees" });
      const caseCat = await catFetch("case");

      setFormData(prev => ({
        ...prev,
        cats: cats,
        wards: wards,
        pkgs: pkgs,
        case: caseCat,
        ipd_reg_charges: (hospCharges[0] && hospCharges[0].cat_type1) || prev.ipd_reg_charges || 0
      }));
    } catch (err) {
      // ignore
    }
  };

  const initData2 = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (!storedData) return;
    try {
      const fd0w = new FormData();
      fd0w.append('page_no', "none");
      fd0w.append('bed_user',"");
      const response = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl, fd0w, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response.data.status) {
        const records = response.data.records || [];
        setFormData(prev => ({ ...prev, beds: records }));
      }
    } catch (err) {
      //console.error("initData2 error:", err);
    }
  };

  // small helper used above
  const prevHasTests = (fn) => {
    return formData.tests1 && formData.tests1.length > 0;
  };

  // ---------- lifecycle ----------
  useEffect(() => {
    console.log('Component mounted');
    const storedUser = getStoredUser();
    if (storedUser) {
      setLdata(storedUser);
      const maybeIsAdmin =
        storedUser.is_admin === 1 ||
        storedUser.isAdmin === 1 ||
        storedUser.role === 'admin' ||
        storedUser.user_type === 'admin' ||
        storedUser.role_id === 1 || storedUser.role_id === "1" ||
        storedUser.user_role === 'admin';
      setIsAdmin(Boolean(maybeIsAdmin));
    } else {
      setLdata(null);
      setIsAdmin(false);
    }

    const todayStr = getLocalYYYYMMDD();

    // ✅ Set date inputs to today for UI display only
    setFormData(prev => ({ ...prev, from: todayStr, to: todayStr }));

    // ✅ Keep ref with EMPTY dates so initData() always fetches ALL records
    filtersRef.current = { from: '', to: '', search_key: '' };

    // ✅ Fetch ALL records (no date filter on server)
    initData({ from: "", to: "" });

    return () => { console.log('Component unmounted'); };
  }, []);


  useEffect(() => {
    initData1();
    initData3();
    initData2();
  }, []);

  // fetch config header logo
  const fetchConfigData = async () => {
    try {
      const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
      if (res.data.status) {
        const data = res.data;
        setHeaderLogo(data.header_logo);
      }
    } catch (err) {
      //console.error("Error fetching config:", err);
    }
  };
  useEffect(() => { fetchConfigData(); }, []);


  // image -> base64 helper used by your PDF logic (unchanged)
  const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
      const response = await fetch(url);
      if (!response.ok) return null;
      const blob = await response.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      //console.error("Error converting image to Base64:", error);
      return null;
    }
  };

  // keep your getDoctorNameById / findNameById / formatDate utilities (unchanged)
  // function getDoctorNameById(id) {
  //   const doctor = formData.docs.find(doc => String(doc.user_id) === String(id));
  //   return doctor ? doctor.fname : "Doctor not found";
  // }


  // prefer name present on the row first, then lookup in formData.docs, then fallback to empty string or id
function getDoctorNameById(id, row = null) {
  // If the server already sent a friendly name on the row, use it
  if (row && row.ipd_refer_doctor_name) return row.ipd_refer_doctor_name;

  // fallback to client-side doctor list lookup
  const doctor = formData.docs.find(doc => String(doc.user_id) === String(id));
  if (doctor && doctor.fname) return doctor.fname;

  // last resort: return blank (or an id string for debugging)
  return id ? String(id) : '';
}

  const findNameById = (id, array = [], idField = 'id', nameField = 'name') => {
    if (!id) return '';
    const item = array.find(i => String(i[idField]) === String(id));
    return item ? item[nameField] : '';
  };

  function formatDate(dateStr) {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date)) return dateStr;
    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
 // Robust: always create a LOCAL Date from server strings like:
// "2025-10-07", "2025-10-07 00:00:34", "2025-10-07T00:00:34"
function parseServerDateToLocal(dateStr) {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return dateStr;

  // Normalize whitespace -> T so regex is simpler
  const normalized = String(dateStr).trim().replace(' ', 'T');

  // Match YYYY-MM-DD optionally followed by T HH:MM:SS (seconds optional)
  const m = normalized.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
  if (!m) return null;

  const year = Number(m[1]);
  const monthIndex = Number(m[2]) - 1; // JS months are 0-based
  const day = Number(m[3]);
  const hour = Number(m[4] ?? 0);
  const minute = Number(m[5] ?? 0);
  const second = Number(m[6] ?? 0);

  // Construct using numeric args -> this is ALWAYS local time
  return new Date(year, monthIndex, day, hour, minute, second);
}

function formatServerDateLocal(dateStr, opts = { locale: 'en-GB', options: { day: '2-digit', month: 'long', year: 'numeric' } }) {
  const dt = parseServerDateToLocal(dateStr);
  if (!dt) return '';
  return dt.toLocaleDateString(opts.locale, opts.options);
}

  // ---------- keep your full generateAdmissionPdf function exactly as provided ----------
  const generateAdmissionPdf = async (data) => {
    const doc = new jsPDF('p', 'pt', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 40;
    let y = 0; // To keep track of vertical position

    const headerImageBase64 = await imageUrlToBase64(headerLogo);

    // 1. === Header Image ===
    if (headerImageBase64) {
      doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 80);
    }

    y = 90; // Starting Y for the next section

    // 2. === Title: "ADMISSION RECORD" ===
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.setDrawColor(0);
    doc.rect(margin, y, pageWidth - (margin * 2), 25);
    doc.text("ADMISSION RECORD", pageWidth / 2, y + 16, { align: 'center' });
    y += 45;

    // 3. === Patient Details Section (Two Columns) ===
    doc.setFontSize(10);
    const leftColX = margin + 10;
    const rightColX = pageWidth / 2 + 80;
    const labelWidth = 90;

    const printDetailLine = (label, value, x, currentY) => {
      doc.setFont('helvetica', 'normal');
      doc.text(label, x, currentY);
      doc.text(":", x + labelWidth, currentY);
      doc.setFont('helvetica', 'normal');
      doc.text(String(value || ''), x + labelWidth + 10, currentY);
    };

    let detailsY = y;
    printDetailLine("UHID No", data.uhid, leftColX, detailsY);
    printDetailLine("IPD No", data.patientRegNo, rightColX, detailsY);
    detailsY += 14;

    printDetailLine("Patient Name", data.patientName, leftColX, detailsY);
    printDetailLine("Age / Gender", data.ageGender, rightColX, detailsY);
    detailsY += 14;
    
    printDetailLine("Address", `${data.address || ''}${data.city ? ', ' + data.city : ''}`, leftColX, detailsY);
    printDetailLine("Phone No.", data.phone, rightColX, detailsY);
    detailsY += 14;

    printDetailLine("Ward", data.ward, leftColX, detailsY);
    printDetailLine("Bed", data.bed, rightColX, detailsY);
    detailsY += 14;

    printDetailLine("Guardian", data.guardian, leftColX, detailsY);
    printDetailLine("Admission Date", formatDate(data.admissionDate), rightColX, detailsY);
    detailsY += 14;

    printDetailLine("Referred Doctor", data.referredDoctor, leftColX, detailsY);
    printDetailLine("Department", data.department, rightColX, detailsY);

    y = detailsY + 25;

    // 4. === Payment History Table ===
    // autoTable(doc, {
    //   startY: y,
    //   head: [['Sl.No', 'Particular', 'Payment Method', 'Amount (Rs)']],
    //   body: data.payments,
    //   theme: 'grid',
    //   headStyles: {
    //     fillColor: [255, 255, 255],
    //     textColor: 0,
    //     fontStyle: 'bold',
    //     lineWidth: 0.5,
    //     lineColor: [0, 0, 0],
    //   },
    //   styles: {
    //     fontSize: 10,
    //     cellPadding: 5,
    //     lineWidth: 0.5,
    //     lineColor: [0, 0, 0]
    //   },
    //   columnStyles: {
    //     0: { cellWidth: 50, halign: 'center' },
    //     3: { halign: 'right' }
    //   },
    //   margin: { left: margin, right: margin }
    // });

    // let finalY = doc.lastAutoTable.finalY;

    // // 5. === Summary Section ===
    // finalY += 25;
    // const summaryLabelColX = pageWidth - 220;
    // const summaryValueColX = pageWidth - margin;

    // const printSummaryLine = (label, value) => {
    //   doc.setFontSize(10);
    //   doc.setFont('helvetica', 'normal');
    //   doc.text(label, summaryLabelColX, finalY, { align: 'left' });
    //   doc.text(':', summaryLabelColX + 100, finalY);
    //   doc.setFont('helvetica', 'bold');
    //   doc.text('Rs.', summaryValueColX - 60, finalY, { align: 'left' });
    //   doc.text(value.toFixed(2), summaryValueColX, finalY, { align: 'right' });
    //   finalY += 15;
    // };
    // const due = parseInt(data.summary.regCharges - data.summary.advanced);

    // printSummaryLine("Registration Charges", data.summary.regCharges);
    // printSummaryLine("Package Charges", data.summary.pkgCharges);
    // printSummaryLine("Total Amount", data.summary.total);
    // printSummaryLine(" Total Advanced", data.summary.advanced);
    // const advanced = parseInt(data.summary.advanced) || 0;
    // const final = parseInt(data.summary.final) || 0;
    // const remainingAdvanced = advanced === 0 ? 0 : Math.max(advanced - final, 0);
    // printSummaryLine("Remaining Advanced", remainingAdvanced);

    // // 6. === Authorized Signature ===
    // const signatureX = pageWidth - margin;
    // const signatureY = finalY + 40;
    // doc.setFontSize(10);
    // doc.setFont('helvetica', 'normal');
    // doc.text(data.signatureName, signatureX, signatureY - 5, { align: 'right' });
    // doc.line(signatureX - 150, signatureY, signatureX, signatureY);
    // doc.text("Authorized Signature", signatureX, signatureY + 15, { align: 'right' });

    // 7. === Open the PDF ===
    const pdfBlobUrl = doc.output('bloburl');
    window.open(pdfBlobUrl, '_blank');
  };

  // ---------- handlePrint (prepare data and call generateAdmissionPdf) ----------
  const handlePrint = (fullData, patientIndex) => {
    const patientData = fullData.l1[patientIndex];
    if (!patientData) {
      //console.error("Patient not found at index:", patientIndex);
      return;
    }

    function getDoctorNameByIdLocal(id) {
      const doctor = fullData.docs.find(doc => String(doc.user_id) === String(id));
      return doctor ? doctor.fname : "Not found";
    }

    function findNameByIdLocal(id, array = [], idField = 'id', nameField = 'name') {
      if (!id || !array) return '';
      const item = array.find(i => String(i[idField]) === String(id));
      return item ? item[nameField] : '';
    }

    const admissionData = {
      uhid: patientData.ipd_uhid || '0001',
      patientRegNo: patientData.ipd_display_no
      || (patientData.ipd_id ? `IP/26/${String(patientData.ipd_id).padStart(3, '0')}` : '00010'),
      patientName: patientData.ipd_patient_name,
      ageGender: `Years / ${patientData.ipd_patient_gender}`,
      address: patientData.ipd_address,
      city: patientData.ipd_city,
      phone: patientData.ipd_patient_mobile,
      guardian: patientData.ipd_guardien_name,
      admissionDate: patientData.ipd_reg_date,
      // Prefer backend-provided friendly names if available, else fallback to local lookup
      ward: patientData.ipd_ward_name ? patientData.ipd_ward_name : findNameByIdLocal(patientData.ipd_ward, fullData.wards, 'cat_id', 'cat_name'),
      bed: patientData.ipd_bed_name ? patientData.ipd_bed_name : findNameByIdLocal(patientData.ipd_bed, fullData.beds, 'bed_id', 'bed_name'),
      department: patientData.ipd_specality_name ? patientData.ipd_specality_name : findNameByIdLocal(patientData.ipd_specality, fullData.cats, 'cat_id', 'cat_name'),
      referredDoctor: getDoctorNameByIdLocal(patientData.ipd_refer_doctor),

      payments: [[
        '1.',
        'Registration Fees',
        patientData.ipd_pay_mode || 'Cash',
        (parseFloat(patientData.ipd_reg_charges) || 0).toFixed(2),
      ]],

      summary: {
        regCharges: parseFloat(patientData.ipd_reg_charges) || 0,
        pkgCharges: parseFloat(patientData.ipd_pkg_price) || 0,
        total: (parseFloat(patientData.ipd_reg_charges) || 0) + (parseFloat(patientData.ipd_pkg_price) || 0),
        advanced: parseFloat(patientData.ipd_advance) || 0,
        paid: parseFloat(patientData.ipd_paid) || 0,
        RemainingAdvance: (parseFloat(patientData.ipd_advance) || 0) - ((parseFloat(patientData.ipd_reg_charges) || 0) + (parseFloat(patientData.ipd_pkg_price) || 0)),
      },

      signatureName: '',
    };

    generateAdmissionPdf(admissionData);
    console.log('--- Prepared Data for PDF ---', admissionData);
  };
  const daysBetween = (d1, d2) => {
    const dt1 = new Date(d1), dt2 = new Date(d2);
    if (isNaN(dt1) || isNaN(dt2)) return Infinity;
    return Math.floor(Math.abs(dt2 - dt1) / (1000 * 60 * 60 * 24));
  };
  
  // ---------- Filtering (date range + search) ----------
  // ---------- Filtering (date range + search) ----------
// ---------- Filtering (search ignores date when active) ----------
const filteredList = useMemo(() => {
  const list = formData.l1 || [];
  const fromDate = formData.from ? new Date(formData.from + 'T00:00:00') : null;
  const toDate   = formData.to   ? new Date(formData.to + 'T23:59:59.999') : null;
  const rawSearch = (formData.search_key || "").toString().toLowerCase().trim();

  return list.filter(item => {
    // ✅ IF SEARCH KEY EXISTS, IGNORE DATE FILTERING
    if (rawSearch) {
      // normalize candidate fields to lowercase strings
      const candidates = [
        item.ipd_uhid,
        item.opd_uhid_move,
        item.opd_uhid,
        item.lab_reg_uhid,
        item.ipd_patient_name,
        item.lab_reg_name,
        item.name,
        item.ipd_patient_mobile,
        item.ipd_cont_number,
        item.mobile,
        item.ipd_patient_phone,
        item.ipd_bill_patient_phone,
        (`000${item.ipd_id}`) // IPD number search
      ].filter(Boolean).map(x => String(x).toLowerCase());

      // if any candidate contains the search text -> match (ignore date)
      return candidates.some(c => c.includes(rawSearch));
    }

    // ✅ IF NO SEARCH KEY, APPLY DATE FILTER
    let itemDate = null;
    if (item.ipd_reg_date) itemDate = parseServerDateToLocal(item.ipd_reg_date);
    else if (item.ipd_datetime) itemDate = parseServerDateToLocal(item.ipd_datetime);

    if (fromDate || toDate) {
      if (!itemDate) return false;
      if (fromDate && itemDate < fromDate) return false;
      if (toDate && itemDate > toDate) return false;
    }

    return true;
  });
}, [formData.l1, formData.from, formData.to, formData.search_key, formData.docs, formData.wards, formData.beds]);

  // Recalculate totals from the currently displayed (filtered) list
  useEffect(() => {
    const list = filteredList || [];
  
    let totalAmount = 0;
    let AdvanceAmount = 0;
    let paidAmount = 0;
    let PkgAmount = 0;
    let totalRegCharges = 0;
  
    list.forEach(item => {
      // support multiple possible field names and ensure numeric values
      const reg = parseFloat(item.ipd_reg_charges ?? item.reg_charges ?? 0) || 0;
      const pkg = parseFloat(item.ipd_pkg_price ?? item.pkg_price ?? 0) || 0;
      const advance = parseFloat(item.ipd_advance ?? item.advance ?? 0) || 0;
      const paid = parseFloat(item.ipd_paid ?? item.paid ?? 0) || 0;
  
      totalAmount += (reg + pkg);
      totalRegCharges += reg;
      AdvanceAmount += advance;
      paidAmount += paid;
      PkgAmount += pkg;
    });
  
    setTotals({
      totalAmount: Number(totalAmount.toFixed(2)),
      AdvanceAmount: Number(AdvanceAmount.toFixed(2)),
      paidAmount: Number(paidAmount.toFixed(2)),
      PkgAmount: Number(PkgAmount.toFixed(2)),
      totalRegCharges: Number(totalRegCharges.toFixed(2))
    });
  }, [filteredList]);
  
  // ---------- DataTable custom styles (header color, font sizes) ----------
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f1f5fb',
        color: '#405189',
        fontSize: '15px',      // larger header text
        fontWeight: '700',
        paddingLeft: '14px',
        paddingRight: '14px',
      }
    },
    rows: {
      style: {
        fontSize: '16px', // row font size
        minHeight: '58px',
      },
    },
    cells: {
      style: {
        paddingLeft: '14px',
        paddingRight: '14px',
        fontSize: '15px',      // larger body text
        lineHeight: '20px'
      }
    },
  };

  // ---------- columns including action column with Edit/Delete buttons ----------

  // Rendered underneath every data row (always visible because we force expand)
// place this inside IpdPataintList (above columns)
const ExpandedActions = ({ data: row }) => {
  // helper to check admission age (uses daysBetween already in your file)
  const isOlderThan10Days = (dateStr) => {
    if (!dateStr) return false;
    try {
      return daysBetween(dateStr, new Date()) > 10;
    } catch (e) {
      return false;
    }
  };

  // inside ExpandedActions component in IpdPataintList.js
// replace the existing toSessionAndNavigate inside ExpandedActions with this
// Place this inside ExpandedActions component in IpdPataintList.js
const toSessionAndNavigate = async (key, path, extra = {}) => {
  if (!row) return;

  // ============================================
  // LAB PREFILL
  // ============================================
  if (key === 'lab_prefill') {
    const labPayload = {
      // Patient identification
      lab_reg_uhid: row.ipd_uhid || row.opd_uhid_move || row.lab_reg_uhid || row.opd_uhid || row.uhid || "",
      lab_reg_id: "", // new registration
      
      // Patient details
      lab_reg_name_title: row.ipd_patient_title || row.patient_title || "Mr.",
      lab_reg_name: row.ipd_patient_name || row.lab_reg_name || row.name || "",
      lab_reg_gender: row.ipd_patient_gender || row.ipd_gender || row.gender || "Male",
      lab_reg_address: row.ipd_address || row.lab_reg_address || row.address || "",
      lab_reg_city: row.ipd_city || row.city || "",
      lab_reg_state: row.ipd_state || row.state || "",
      lab_reg_mobile: row.ipd_patient_mobile || row.ipd_cont_number || row.mobile || "",
      
      // Age fields - preserve original values
      lab_reg_age_year: row.ipd_age_year || row.ipd_patient_age || row.lab_reg_age_year || row.age_year || "0",
      lab_reg_age_month: row.ipd_age_month || row.lab_reg_age_month || row.age_month || "0",
      lab_reg_age_day: row.ipd_age_day || row.lab_reg_age_day || row.age_day || "0",
      
      // Guardian
      lab_guardian_title: row.ipd_guardien_title || row.guardian_title || "C/O",
      lab_guardian_name: row.ipd_guardien_name || row.guardian_name || "",
      
      // Referral doctor - use ID and name
      lab_reg_referral: row.ipd_refer_doctor_name || getDoctorNameById(row.ipd_refer_doctor, row) || "",
      lab_reg_referral_id: row.ipd_refer_doctor || "",
      
      // Registration details
      lab_reg_type: "IPD", // Mark as IPD source
      lab_reg_date: (() => {
        const src = row.ipd_reg_date || row.reg_date || row.ipd_datetime || "";
        if (!src) return "";
        try {
          const dt = parseServerDateToLocal(src);
          if (!dt || isNaN(dt.getTime())) return String(src);
          const YYYY = dt.getFullYear();
          const MM = String(dt.getMonth() + 1).padStart(2, "0");
          const DD = String(dt.getDate()).padStart(2, "0");
          return `${YYYY}-${MM}-${DD}`;
        } catch (e) {
          return String(src);
        }
      })(),
      
      // Collection location
      lab_collected_at: row.lab_collected_at || "",
      
      // Broker info
      lab_reg_broker_id: row.ipd_broker_id || row.broker_id || "",
      lab_reg_broker_name: row.ipd_broker_name || row.broker_name || "",
      
      // Payment defaults (lab will calculate based on tests)
      lab_total: "0",
      lab_dis_per: "0",
      lab_fix_deposit: "0",
      lab_final_amt: "0",
      lab_paid: "0",
      lab_due: "0",
      lab_pay_mode: "Cash",
      lab_remarks: `Referred from IPD - ${row.ipd_id ? `IPD No: 000${row.ipd_id}` : ''}`,
      
      // Tests array (empty - user will select)
      tests1: [],
      params: [],
      all_tests: [],
      
      // Metadata flags
      is_prefilled: true,
      source_type: "ipd",
      source_id: row.ipd_id || "",
      ipd_id: row.ipd_id || "",
      lab_ipd_id: row.ipd_id || "",
      ...extra
    };

    console.log("🔵 Lab prefill payload:", labPayload);

    try {
      sessionStorage.setItem(key, JSON.stringify(labPayload));
      console.log("✅ Lab data saved to sessionStorage");
    } catch (e) {
      console.warn('Could not set lab_prefill in sessionStorage', e);
    }

    navigate(path);
    return;
  }

  // ============================================
  // OT PREFILL
  // ============================================
  if (key === 'ot_dt') {
    const otPayload = {
      // OT-friendly keys
      ot_uhid_no: row.ipd_uhid || row.opd_uhid_move || row.lab_reg_uhid || row.opd_uhid || row.uhid || "",
      ot_ipd_no: row.ipd_id || row.lab_reg_id || row.ipd_no || "",
      ot_patient_name: row.ipd_patient_name || row.lab_reg_name || row.name || "",
      ot_patient_mobile: row.ipd_patient_mobile || row.ipd_cont_number || row.mobile || "",
      ot_patient_address: row.ipd_address || row.lab_reg_address || row.address || "",
      
      // Age - keep as string
      ot_patient_age: row.ot_patient_age || row.ipd_patient_age || row.ipd_age || row.lab_reg_age || row.age || row.patient_age || "",
      
      ot_patient_gender: row.ipd_patient_gender || row.ipd_gender || row.gender || "",
      
      // OT Doctor
      ot_doctor: row.ot_doctor || row.ipd_ot_doctor || "",
      ot_doctor_name: row.ot_doctor_name || "",
      
      // Assistant OT Doctor
      ot_asst_doctor: row.ot_asst_doctor || row.ipd_asst_doctor || "",
      ot_asst_doctor_name: row.ot_asst_doctor_name || "",
      
      // Anesthesia Doctor
      ot_anesthesia_doctor: row.ot_anesthesia_doctor || row.ipd_anesthesia_doctor || "",
      ot_anesthesia_doctor_name: row.ot_anesthesia_doctor_name || "",
      
      // Registration date
      ot_reg_date: (() => {
        const src = row.ipd_reg_date || row.reg_date || row.admit_date || row.ipd_datetime || "";
        if (!src) return "";
        try {
          const dt = parseServerDateToLocal(src);
          if (!dt || isNaN(dt.getTime())) return String(src);
          const YYYY = dt.getFullYear();
          const MM = String(dt.getMonth() + 1).padStart(2, "0");
          const DD = String(dt.getDate()).padStart(2, "0");
          return `${YYYY}-${MM}-${DD}`;
        } catch (e) {
          return String(src);
        }
      })(),
      
      ot_datetime: row.ipd_datetime || row.created_at || "",
      ot_bed: row.ipd_bed || row.bed || "",
      ot_bed_name: row.ipd_bed_name || row.bed_name || "",
      ot_case: row.ipd_case || row.case_id || row.cat_id || row.ipd_case_name || row.case_name || "",
      ot_ref_doctor: row.ipd_refer_doctor || row.ipd_refer_doctor_name || "",
      
      // IPD billing aliases
      ipd_bill_uhid: row.ipd_uhid || row.lab_reg_uhid || "",
      ipd_bill_ipd_id: row.ipd_id || row.lab_reg_id || row.ipd_no || "",
      ipd_bill_patient_name: row.ipd_patient_name || row.lab_reg_name || row.name || "",
      ipd_bill_patient_phone: row.ipd_patient_mobile || row.ipd_cont_number || row.mobile || "",
      ipd_bill_patient_address: row.ipd_address || row.lab_reg_address || "",
      ipd_bill_patient_age: row.ipd_bill_patient_age || row.ipd_patient_age || row.ipd_age || row.age || "",
      
      // Pass-through fields
      ipd_id: row.ipd_id || "",
      ipd_bill_id: row.ipd_bill_id || "",
      ipd_reg_date: row.ipd_reg_date || "",
      ipd_datetime: row.ipd_datetime || row.created_at || "",
      ipd_bed: row.ipd_bed || row.bed || "",
      ipd_bed_name: row.ipd_bed_name || row.bed_name || "",
      ipd_ward: row.ipd_ward || row.ward || "",
      ipd_ward_name: row.ipd_ward_name || row.ward_name || "",
      ipd_refer_doctor: row.ipd_refer_doctor || "",
      ipd_refer_doctor_name: row.ipd_refer_doctor_name || "",
      otitems: row.otitems || row.items || [],
      
      ...extra
    };

    // 10-day OT guard
    const reg = otPayload.ot_reg_date || otPayload.ot_datetime || "";
    if (reg) {
      try {
        const regDate = new Date(String(reg).replace(' ', 'T'));
        const days = Math.floor((Date.now() - regDate.getTime()) / (1000 * 60 * 60 * 24));
        if (days > 10) {
          Swal.fire({
            icon: 'error',
            title: 'Cannot add OT',
            text: `Patient admission is ${days} days ago — cannot add OT for >10 days.`,
          });
          return;
        }
      } catch (e) {
        // ignore parse errors
      }
    }

    try {
      sessionStorage.setItem(key, JSON.stringify(otPayload));
      console.log("✅ OT data saved to sessionStorage");
    } catch (e) {
      console.warn('sessionStorage set failed', e);
    }

    navigate(path);
    return;
  }

  // ============================================
  // BED DETAILS PREFILL
  // ============================================
  if (key === 'bed_prefill') {
    const bedPayload = {
      ipd_uhid: row.ipd_uhid || "",
      ipd_id: row.ipd_id || "",
      ipd_patient_name: row.ipd_patient_name || "",
      ipd_patient_mobile: row.ipd_patient_mobile || row.ipd_cont_number || "",
      ipd_bed: row.ipd_bed || "",
      ipd_bed_name: row.ipd_bed_name || "",
      ipd_ward: row.ipd_ward || "",
      ipd_ward_name: row.ipd_ward_name || "",
      ipd_reg_date: row.ipd_reg_date || "",
      ...extra
    };

    try {
      sessionStorage.setItem(key, JSON.stringify(bedPayload));
    } catch (e) {
      console.warn('sessionStorage set failed', e);
    }

    navigate(path);
    return;
  }

  // ============================================
  // TPR SHEET PREFILL
  // ============================================
  // ============================================
// TPR SHEET PREFILL
// ============================================
// ============================================
// TPR SHEET PREFILL - ENHANCED WITH OT DOCTOR FETCH
// ============================================
if (key === 'tpr_prefill') {
  // Initialize payload with row data
  let tprPayload = {
    ipd_uhid: row.ipd_uhid || "",
    ipd_id: row.ipd_id || "",
    ipd_patient_name: row.ipd_patient_name || "",
    ipd_patient_mobile: row.ipd_patient_mobile || "",
    ipd_patient_age: row.ipd_patient_age || row.ipd_age || "",
    ipd_patient_gender: row.ipd_patient_gender || "",
    ipd_bed: row.ipd_bed || "",
    ipd_ward: row.ipd_ward || "",
    ipd_reg_date: row.ipd_reg_date || "",
    
    // ✅ Referring doctor (consultant) - from IPD record
    ipd_refer_doctor: row.ipd_refer_doctor || "",
    ipd_refer_doctor_name: row.ipd_refer_doctor_name || getDoctorNameById(row.ipd_refer_doctor, row) || "",
    
    // ✅ OT doctor - will be fetched from OT table
    ot_doctor: row.ot_doctor || "",
    ot_doctor_name: row.ot_doctor_name || "",
    
    ...extra
  };

  // ✅ Fetch OT doctor from OT table if UHID exists
  const uhid = row.ipd_uhid || row.ipd_bill_uhid || row.lab_reg_uhid || "";
  if (uhid) {
    try {
      const fd = new FormData();
      fd.append('ot_uhid_no', uhid);
      
      const otResp = await axios.post(
        AppConst.BASE_URL + AppConst.getOtByUhidUrl, 
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      
      if (otResp?.data?.status && otResp.data.ot_dt) {
        const otData = otResp.data.ot_dt;
        
        // Update payload with OT doctor info
        tprPayload.ot_doctor = otData.ot_doctor || tprPayload.ot_doctor;
        tprPayload.ot_doctor_name = otData.ot_doctor_name || tprPayload.ot_doctor_name;
        
        console.log("✅ OT Doctor fetched from OT table:", {
          ot_doctor: tprPayload.ot_doctor,
          ot_doctor_name: tprPayload.ot_doctor_name
        });
      }
    } catch (err) {
      console.warn("Could not fetch OT doctor from OT table:", err);
    }
  }

  console.log("🔵 TPR Prefill - Final payload:", tprPayload);

  try {
    sessionStorage.setItem(key, JSON.stringify(tprPayload));
    console.log("✅ TPR data saved to sessionStorage");
  } catch (e) {
    console.warn('sessionStorage set failed', e);
  }

  navigate(path);
  return;
}

   

 
if (key === 'medsheet_prefill') {
  // Initialize payload with row data
  let medsheetPayload = {
    ipd_uhid: row.ipd_uhid || "",
    uhid: row.ipd_uhid || "",
    ipd_id: row.ipd_id || "",
    ipd_patient_name: row.ipd_patient_name || "",
    name: row.ipd_patient_name || "",
    ipd_patient_mobile: row.ipd_patient_mobile || "",
    mobile: row.ipd_patient_mobile || "",
    ipd_patient_age: row.ipd_patient_age || row.ipd_age || "",
    age: row.ipd_patient_age || row.ipd_age || "",
    ipd_patient_gender: row.ipd_patient_gender || "",
    gender: row.ipd_patient_gender || "",
    ipd_bed: row.ipd_bed || "",
    ipd_ward: row.ipd_ward || "",
    ipd_reg_date: row.ipd_reg_date || "",
    
    // ✅ Referring doctor (consultant) - from IPD record
    ipd_refer_doctor: row.ipd_refer_doctor || "",
    ot_ref_doctor: row.ipd_refer_doctor || "",
    
    // ✅ OT doctor - will be fetched from OT table
    ot_doctor: row.ot_doctor || "",
    
    ...extra
  };

  // ✅ Fetch OT doctor from OT table if UHID exists
  const uhid = row.ipd_uhid || row.ipd_bill_uhid || row.lab_reg_uhid || "";
  if (uhid) {
    try {
      const fd = new FormData();
      fd.append('ot_uhid_no', uhid);
      
      const otResp = await axios.post(
        AppConst.BASE_URL + AppConst.getOtByUhidUrl, 
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      
      if (otResp?.data?.status && otResp.data.ot_dt) {
        const otData = otResp.data.ot_dt;
        
        // Update payload with OT doctor info
        medsheetPayload.ot_doctor = otData.ot_doctor || medsheetPayload.ot_doctor;
        medsheetPayload.ot_ref_doctor = otData.ot_ref_doctor || medsheetPayload.ot_ref_doctor || medsheetPayload.ipd_refer_doctor;
        
        console.log("✅ MedSheet - OT Doctor fetched:", {
          ot_doctor: medsheetPayload.ot_doctor,
          ot_ref_doctor: medsheetPayload.ot_ref_doctor
        });
      }
    } catch (err) {
      console.warn("Could not fetch OT doctor from OT table:", err);
    }
  }

  console.log("🔵 MedSheet Prefill - Final payload:", medsheetPayload);

  try {
    sessionStorage.setItem(key, JSON.stringify(medsheetPayload));
    console.log("✅ MedSheet data saved to sessionStorage");
  } catch (e) {
    console.warn('sessionStorage set failed', e);
  }

  navigate(path);
  return;
}

  // ============================================
  // PATIENT HISTORY PREFILL
  // ============================================
  if (key === 'history_prefill') {
    const historyPayload = {
      ipd_uhid: row.ipd_uhid || "",
      ipd_id: row.ipd_id || "",
      ipd_patient_name: row.ipd_patient_name || "",
      ipd_patient_mobile: row.ipd_patient_mobile || "",
      ipd_patient_age: row.ipd_patient_age || row.ipd_age || "",
      ipd_patient_gender: row.ipd_patient_gender || "",
      ipd_address: row.ipd_address || "",
      ipd_reg_date: row.ipd_reg_date || "",
      ipd_case: row.ipd_case || "",
      ipd_refer_doctor: row.ipd_refer_doctor || "",
      ipd_refer_doctor_name: row.ipd_refer_doctor_name || "",
      ...extra
    };

    try {
      sessionStorage.setItem(key, JSON.stringify(historyPayload));
    } catch (e) {
      console.warn('sessionStorage set failed', e);
    }

    navigate(path);
    return;
  }

  // ============================================
  // DEFAULT/FALLBACK BEHAVIOR
  // ============================================
  // If no specific key matched, build a generic payload
  const genericPayload = {
    // OT-friendly keys (used by your AddOt component)
    ot_uhid_no: row.ipd_uhid || row.opd_uhid_move || row.lab_reg_uhid || row.opd_uhid || row.uhid || "",
    ot_ipd_no: row.ipd_id || row.lab_reg_id || row.ipd_no || "",
    ot_patient_name: row.ipd_patient_name || row.lab_reg_name || row.name || "",
    ot_patient_mobile: row.ipd_patient_mobile || row.ipd_cont_number || row.mobile || "",
    ot_patient_address: row.ipd_address || row.lab_reg_address || row.address || "",
    ot_patient_age: row.ot_patient_age || row.ipd_patient_age || row.ipd_age || row.lab_reg_age || row.age || row.patient_age || "",
    ot_patient_gender: row.ipd_patient_gender || row.ipd_gender || row.gender || "",
    ot_doctor: row.ot_doctor || row.ipd_ot_doctor || "",
    ot_doctor_name: row.ot_doctor_name || "",
    ot_asst_doctor: row.ot_asst_doctor || row.ipd_asst_doctor || "",
    ot_asst_doctor_name: row.ot_asst_doctor_name || "",
    ot_anesthesia_doctor: row.ot_anesthesia_doctor || row.ipd_anesthesia_doctor || "",
    ot_anesthesia_doctor_name: row.ot_anesthesia_doctor_name || "",
    ot_reg_date: (() => {
      const src = row.ipd_reg_date || row.reg_date || row.admit_date || row.ipd_datetime || "";
      if (!src) return "";
      try {
        const dt = parseServerDateToLocal(src);
        if (!dt || isNaN(dt.getTime())) return String(src);
        const YYYY = dt.getFullYear();
        const MM = String(dt.getMonth() + 1).padStart(2, "0");
        const DD = String(dt.getDate()).padStart(2, "0");
        return `${YYYY}-${MM}-${DD}`;
      } catch (e) {
        return String(src);
      }
    })(),
    ot_datetime: row.ipd_datetime || row.created_at || "",
    ot_bed: row.ipd_bed || row.bed || "",
    ot_bed_name: row.ipd_bed_name || row.bed_name || "",
    ot_case: row.ipd_case || row.case_id || row.cat_id || row.ipd_case_name || row.case_name || row.ipd_case || "",
    ot_ref_doctor: row.ipd_refer_doctor || row.ipd_refer_doctor_name || "",

    // IPD billing aliases
    ipd_bill_uhid: row.ipd_uhid || row.lab_reg_uhid || "",
    ipd_bill_ipd_id: row.ipd_id || row.lab_reg_id || row.ipd_no || "",
    ipd_bill_patient_name: row.ipd_patient_name || row.lab_reg_name || row.name || "",
    ipd_bill_patient_phone: row.ipd_patient_mobile || row.ipd_cont_number || row.mobile || "",
    ipd_bill_patient_address: row.ipd_address || row.lab_reg_address || "",
    ipd_bill_patient_age: row.ipd_bill_patient_age || row.ipd_patient_age || row.ipd_age || row.age || "",

    // Pass-through useful fields
    ipd_id: row.ipd_id || "",
    ipd_bill_id: row.ipd_bill_id || "",
    ipd_reg_date: row.ipd_reg_date || "",
    ipd_datetime: row.ipd_datetime || row.created_at || "",
    ipd_bed: row.ipd_bed || row.bed || "",
    ipd_bed_name: row.ipd_bed_name || row.bed_name || "",
    ipd_ward: row.ipd_ward || row.ward || "",
    ipd_ward_name: row.ipd_ward_name || row.ward_name || "",
    ipd_refer_doctor: row.ipd_refer_doctor || "",
    ipd_refer_doctor_name: row.ipd_refer_doctor_name || "",
    otitems: row.otitems || row.items || [],

    // Allow caller to override or pass extras
    ...extra
  };

  try {
    sessionStorage.setItem(key, JSON.stringify(genericPayload));
  } catch (e) {
    console.warn('sessionStorage set failed', e);
  }

  // Use react-router navigate to avoid full page reload
  try {
    navigate(path);
  } catch (err) {
    console.warn('navigate() failed, falling back to window.location', err);
    window.location.href = path;
  }
};




  
  return (
    <div style={{ padding: '10px 14px', borderTop: '1px solid #eee', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
     <button className="btn btn-sm btn-outline-primary" onClick={() => toSessionAndNavigate('lab_prefill', '/registrations')}>
        <i className="ri-flask-line"></i>&nbsp;Add Lab
      </button>

      <button className="btn btn-sm btn-outline-secondary" onClick={() => toSessionAndNavigate('ot_dt', '/add_ot')}>
        <i className="ri-scissors-line"></i>&nbsp;Add OT
      </button>

      {/* <button className="btn btn-sm btn-outline-success" onClick={() => toSessionAndNavigate('billing_prefill', '/ipd_billing')}>
        <i className="ri-file-dollar-line"></i>&nbsp;IPD Billing
      </button> */}
<button
  className="btn btn-sm btn-outline-success"
  onClick={() => handleBillingPrefill(row)}
>
  <i className="ri-file-dollar-line"></i>&nbsp;IPD Billing
</button>

      <button className="btn btn-sm btn-outline-info" onClick={() => toSessionAndNavigate('bed_prefill', '/bed_details')}>
        <i className="ri-bed-line"></i>&nbsp;Bed Details
      </button>

      <button className="btn btn-sm btn-outline-dark" onClick={() => toSessionAndNavigate('tpr_prefill', '/tpr_sheet')}>
        <i className="ri-heart-pulse-line"></i>&nbsp;TPR Sheet
      </button>

      <button className="btn btn-sm btn-outline-warning" onClick={() => toSessionAndNavigate('medsheet_prefill', '/med_sheet')}>
        <i className="ri-first-aid-kit-line"></i>&nbsp;Medicine Sheet
      </button>

      <button className="btn btn-sm btn-outline-danger" onClick={() => toSessionAndNavigate('history_prefill', '/patienthis')}>
        <i className="ri-history-line"></i>&nbsp;History
      </button>

      <button className="btn btn-sm btn-success" onClick={() => openAdvanceModal(row)}>
  <i className="ri-money-dollar-circle-line"></i>&nbsp;Add Advance
</button>


<button className="btn btn-sm btn-outline-purple" 
  style={{ borderColor: '#7c3aed', color: '#7c3aed' }}
  onClick={() => openOrderModal(row)}>
  <i className="ri-file-list-3-line"></i>&nbsp;Order
</button>
 
<button className="btn btn-sm btn-outline-teal"
  style={{ borderColor: '#0d9488', color: '#0d9488' }}
  onClick={() => {
    setOrderTreatmentPatient(row);
    setShowOrderTreatmentModal(true);
    // Will open on treatment tab - handled by the modal
  }}>
  <i className="ri-medicine-bottle-line"></i>&nbsp;Treatment
</button>
    </div>
  );
};


  const columns = [
    
    
    {
      name: 'Action',
      cell: row => {
        // prefer ipd_datetime (admission datetime) else fallback to ipd_reg_date
        const regStr = row.ipd_datetime || row.ipd_reg_date || null;
        const regDate = regStr ? new Date(regStr) : null;
    
        // modified_at might be present on row or nested ipd_row/post_ipd
        let modifiedAt = null;
        if (row.modified_at) modifiedAt = new Date(row.modified_at);
        else if (row.ipd_row && row.ipd_row.modified_at) modifiedAt = new Date(row.ipd_row.modified_at);
        else if (row.post_ipd && row.post_ipd.modified_at) modifiedAt = new Date(row.post_ipd.modified_at);
    
        // compute "latest" timestamp: the one that controls the 24h window
        const candidates = [];
        if (regDate) candidates.push(regDate);
        if (modifiedAt) candidates.push(modifiedAt);
    
        // If we have timestamps, pick the latest; otherwise latestTs is null
        const latestTs = candidates.length ? candidates.reduce((a,b) => (a.getTime() > b.getTime() ? a : b)) : null;
    
        const MS_24H = 24 * 60 * 60 * 1000;
        const now = Date.now();
        
        // detect stored user role_id === 1 directly from sessionStorage (simple and reliable)
        let storedRoleIsAdmin = false;
        try {
          const raw = sessionStorage.getItem('ldata');
          if (raw) {
            const parsed = JSON.parse(raw);
            storedRoleIsAdmin = String(parsed?.role_id) === '1' || String(parsed?.roleId) === '1';
          }
        } catch (e) {
          storedRoleIsAdmin = false;
        }
        
        // original editable logic (kept for non-admins)
        const editableByTime = latestTs ? ((now - latestTs.getTime()) < MS_24H) : true;
        
        // If stored role_id === 1 => always editable
        const editable = storedRoleIsAdmin ? true : editableByTime;
        const editBlocked = !editable;
        
        // delete blocked: keep your 24h restriction but allow admins (role_id ===1) to bypass
        const regForDelete = regDate;
        const isOlderThan24FromReg = regForDelete ? (now - regForDelete.getTime()) > MS_24H : false;
        // allow delete if admin, otherwise block if older than 24h or not admin
        const deleteBlocked = !storedRoleIsAdmin && (isOlderThan24FromReg || !isAdmin);
    
        const btnStyle = blocked => ({ opacity: blocked ? 0.5 : 1, cursor: blocked ? 'not-allowed' : 'pointer' });
    
        return (
          <div className="d-flex gap-2">
            {/* EDIT BUTTON */}
            <button
              type="button"
              c className="btn btn-sm btn-outline-warning"
              style={btnStyle(editBlocked)}
              onClick={() => {
                if (editBlocked) {
                  // Decide which timestamp is responsible for the lock to show a clear message
                  if (modifiedAt && (!regDate || modifiedAt.getTime() >= regDate.getTime())) {
                    const unlockAt = new Date(modifiedAt.getTime() + MS_24H);
                    Swal.fire({
                      icon: 'info',
                      title: "Edit Locked (Modified)",
                      html: `This record was last <b>modified</b> on:<br/><b>${modifiedAt.toLocaleString()}</b>.<br/>
                             Editing is locked for 24 hours from the last modification.<br/>
                             You can edit after: <b>${unlockAt.toLocaleString()}</b>`,
                      confirmButtonText: 'OK'
                    });
                  } else if (regDate) {
                    const unlockAt = new Date(regDate.getTime() + MS_24H);
                    Swal.fire({
                      icon: 'info',
                      title: "Edit Locked ",
                      html: `This patient was admitted 24 Hrs before</b>.<br/>
                             
                              </b>`,
                      confirmButtonText: 'OK'
                    });
                  } else {
                    // fallback message if no timestamps present
                    Swal.fire({
                      icon: 'info',
                      title: 'Edit Locked',
                      text: 'Editing is currently not allowed for this record.',
                      confirmButtonText: 'OK'
                    });
                  }
                  return;
                }
    
                // Confirm and navigate to the edit page
                Swal.fire({
                  title: 'Are you sure?',
                  text: "Do you want to edit this patient's record?",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, Edit'
                }).then((result) => {
                  if (result.isConfirmed) {
                    sessionStorage.setItem("ipd_dt", JSON.stringify(row));
                    navigate('/ipd_registrations');
                  }
                });
              }}
            >
              <i className="ri-pencil-fill fs-16"></i>&nbsp;&nbsp;
            </button>
    
            {/* DELETE BUTTON */}
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              style={btnStyle(deleteBlocked)}
              onClick={() => {
                if (deleteBlocked) {
                  const msg = isOlderThan24FromReg ? "Deleting disabled after 24 hours." : "Only admins can delete this record.";
                  Swal.fire({ icon: 'info', title: "Can't Delete", text: msg, confirmButtonText: 'OK' });
                  return;
                }
                Swal.fire({
                  title: 'Are you sure?',
                  text: "This will permanently delete the record.",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Yes, delete it'
                }).then((result) => {
                  if (result.isConfirmed) {
                    delItem(row);
                  }
                });
              }}
            >
              <i className="ri-delete-bin-5-fill fs-16"></i>&nbsp;&nbsp;
            </button>
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '220px'
    },
    
    {
      name: '',
      cell: row => (
        <button
          className="btn btn-sm btn-primary view-btn"
          onClick={(e) => {
            e.stopPropagation();
            openDetails(row);
          }}
          title="View"
          style={{ minWidth: 64 }}
        >
          View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '90px'
    },

    
    {
      name: '',
      cell: (row, index, column, id) => (
        <div className="position-relative z-index-dropdown-fix">
          <button
            className="btn btn-link text-muted p-0"
            type="button"
            onClick={() => {
              setDropdownOpenIndex(prev => prev === row.ipd_id ? null : row.ipd_id);
            }}
          >
            <i className="ri-more-2-fill fs-18"></i>
          </button>

          {dropdownOpenIndex === row.ipd_id && (
            <ul className="dropdown-menu dropdown-menu-end shadow show" style={{ position: "absolute", bottom: "100%", left: 0 }}>
              <li>
                <button
                  className="dropdown-item"
                  onClick={async () => {
                    setShowModal(true);
                    setDropdownOpenIndex(null);
                    const idx = formData.l1.findIndex(i => i.ipd_id === row.ipd_id);
                    await handlePrint(formData, idx);
                  }}
                >
                  Print Admission Form
                </button>
              </li>
            </ul>
          )}
        </div>
      ),
      width: '56px',
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      name: 'SN',
      selector: (row) => {
        const idxInFiltered = filteredList.findIndex(i => i.ipd_id === row.ipd_id);
        return idxInFiltered + 1;
      },
      sortable: true,
      width: '90px'
    },
    // {
    //   name: 'IPD No',
    //   selector: row => `000${row.ipd_id}`,
    //   sortable: true,
    //   width: '170px'
    // },
    {
      name: 'IPD No',
      selector: row => row.ipd_display_no || `000${row.ipd_id}`,
      sortable: true,
      width: '170px'
    },
    
    {
      name: 'UHID',
      selector: row => (row.ipd_remarks === "Moved from OPD" ? row.opd_uhid_move : row.ipd_uhid),
      sortable: true,
       width: '180px'
    },
    {
      name: 'Admission Date',
      selector: row => formatServerDateLocal(row.ipd_reg_date) || '',
      sortable: true,
      width: '180px'
    },
    {
      name: 'Patient Name',
      selector: row => `${row.ipd_patient_title} ${row.ipd_patient_name}`,
      sortable: true,
      width: '170px'
    },
    {
      name: 'Mobile',
      selector: row => row.ipd_cont_number || row.ipd_patient_mobile || '',
      sortable: true
    },
    {
      name: 'Address',
      selector: row => `${row.ipd_address || ''}, ${row.ipd_city || ''}`,
      sortable: true
    },
    {
      name: 'Referred Doctor',
      // pass the whole row so the helper can use server-provided name when available
      selector: row => getDoctorNameById(row.ipd_refer_doctor, row),
      sortable: true,
      width: '180px'
    },
    
    {
      name: 'Ward/Bed',
      // PREFER backend-provided ipd_ward_name / ipd_bed_name then fallback to local lists
      selector: row => `${row.ipd_ward_name ? row.ipd_ward_name : (formData.wards.find(w => w.cat_id === row.ipd_ward)?.cat_name || 'N/A')} / ${row.ipd_bed_name ? row.ipd_bed_name : (formData.beds.find(b => b.bed_id === row.ipd_bed)?.bed_name || 'N/A')}`,
      sortable: true,
       width: '160px'
    },

    {
      name: 'Last Used',
      selector: row => row.last_used || '',
      sortable: true,
      width: '160px'
    },
    
    
  ];

  // delete helper (unchanged)
  const delItem = async (editItem) => {
    const fd = new FormData();

    fd.append('ipd_id', editItem.ipd_id + "");
    attachUserInfo(fd);
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.deleteIpdUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response.data.status) {
        // ✅ FIX: Re-fetch with current filter values
        await initData({
          from: formData.from || '',
          to: formData.to || '',
          search_key: formData.search_key || ''
        });
        toast.success("IPD Record Deleted Successfully");
      }
    } catch (error) {
      console.error("delItem error:", error);
    }
  };

  // ---------- render ----------
  return (
    <div className="page-content">
      <style>{hoverStyle}</style>

      <div className="container-fluid">

        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h2 style={{ color: "#405189" }}>IPD Registrations</h2>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      
                     
                       <button
  type="button"
  className="btn btn-success add-btn"
  onClick={() => {
    try {
      sessionStorage.removeItem("ipd_dt");
    } catch(e) { /* ignore */ }
    // client-side navigate - no full page reload
    navigate('/ipd_registrations');
  }}
>
  <i className="ri-add-line align-bottom me-1"></i> Add Patient
</button>

                     
                      <button className="btn btn-soft-danger" id="remove-actions">
                        <i className="ri-delete-bin-2-line"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                    <div className="col-md-2">
                      <label className="form-label">From</label>
                      <input className="form-control" type="date" name="from" onChange={(e) => updateFilters({ from: e.target.value })} value={formData.from} />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">To</label>
                      <input className="form-control" type="date" name="to" onChange={(e) => updateFilters({ to: e.target.value })} value={formData.to} />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Search</label>
                      <div className="search-box" style={{ display: "flex" }}>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" onClick={() => {
  const todayStr = getLocalYYYYMMDD();
  
  // Reset UI to today
  setFormData(prev => ({ ...prev, search_key: "", from: todayStr, to: todayStr, page_no: 0 }));
  
  // Reset ref
  filtersRef.current = { from: '', to: '', search_key: '' };
  
  // Re-fetch ALL from server
  initData({ from: "", to: "" });
}} className="btn btn-info">Clear</button>


                      </div>
                    </div>
                    <div className="col-md-3"></div>
                    <div className="col-md-3" style={{ textAlign: "right" }}>
                      <label className="form-label"></label>
                      <div className="search-box">
                        <input className="form-control search" placeholder="Search..." type="text"
                          name="search_key" onChange={(e) => updateFilters({ search_key: e.target.value })} value={formData.search_key} />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <br />

              <div className="card-body pt-0">
                <div>
                  <div className="table-responsive table-card mb-1">
                    {/* <DataTable
                      columns={columns}
                      data={filteredList}
                      pagination
                      highlightOnHover
                      responsive
                      persistTableHead
                      customStyles={customStyles}
                      noHeader
                    /> */}

<DataTable
  columns={columns}
  data={filteredList}
  pagination
  highlightOnHover
  responsive
  persistTableHead
  customStyles={customStyles}
  noHeader
  // --- new props for always-visible extra row ---
  expandableRows
  expandableRowsComponent={ExpandedActions}
  
  // always expanded
  expandableRowExpanded={row => true}
  // don't let clicks toggle expand (we keep expand row always visible)
  expandOnRowClicked={false}
/>

                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <div className="pagination-wrap hstack gap-2">
                      <div className="text-muted">
                        <strong>Total Amount:</strong> {(Number(totals.totalAmount || 0) + Number(totals.AdvanceAmount || 0)).toFixed(2)}&nbsp;|&nbsp;
                        <strong>Advance Amount:</strong> {totals.AdvanceAmount} &nbsp;|&nbsp;
                        <strong>Paid Amount:</strong> {totals.paidAmount} &nbsp;|&nbsp;
                        <strong>Package Amount:</strong> {totals.PkgAmount} &nbsp;|&nbsp;
                        <strong>Total Registration Charges:</strong> {totals.totalRegCharges}
                      </div>
                    </div>
                    <div className="pagination-wrap hstack gap-2">
                      <ul className="pagination listjs-pagination mb-0"></ul>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

      {/* ADD ADVANCE MODAL */}
{showAdvanceModal && (
  <div 
    style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      right: 0, 
      bottom: 0, 
      background: 'rgba(0,0,0,0.5)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      zIndex: 9000

      
    }}
    onClick={() => setShowAdvanceModal(false)}
  >
    <div 
      style={{ 
        background: 'white', 
        borderRadius: '12px', 
        width: '90%', 
        maxWidth: '750px', 
        maxHeight: '90vh', 
        overflow: 'hidden',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      
      {/* Header */}
      <div style={{ 
        background: 'linear-gradient(135deg, #405189, #6366f1)', 
        color: 'white', 
        padding: '16px 20px', 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div>
          <h5 style={{ margin: 0, fontWeight: 600 }}>Add Advance Payment</h5>
          <small style={{ opacity: 0.9 }}>
            {selectedPatient?.ipd_patient_name} | UHID: {selectedPatient?.ipd_uhid} | IPD: {selectedPatient?.ipd_display_no || `000${selectedPatient?.ipd_id}`}
          </small>
        </div>
        <button 
          onClick={() => setShowAdvanceModal(false)} 
          style={{ 
            background: 'none', 
            border: 'none', 
            color: 'white', 
            fontSize: '28px', 
            cursor: 'pointer',
            lineHeight: 1 
          }}
        >
          &times;
        </button>
      </div>

      {/* Body */}
      <div style={{ padding: '20px', maxHeight: 'calc(90vh - 80px)', overflowY: 'auto' }}>
        
        {/* Total Advance Box */}
        <div style={{ 
          background: 'linear-gradient(135deg, #e8f5e9, #c8e6c9)', 
          padding: '14px 18px', 
          borderRadius: '10px', 
          marginBottom: '20px', 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span style={{ fontWeight: 600, color: '#2e7d32' }}>Total Advance Paid</span>
          <span style={{ fontSize: '22px', fontWeight: 700, color: '#1b5e20' }}>₹ {totalAdvance.toFixed(2)}</span>
        </div>

        {/* Form Fields */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '20px' }}>
          
          {/* Amount */}
          <div>
            <label style={{ fontWeight: 600, marginBottom: '6px', display: 'block' }}>Amount *</label>
            <input 
              type="number" 
              className="form-control" 
              placeholder="Enter amount"
              value={advanceForm.amount} 
              onChange={(e) => setAdvanceForm({ ...advanceForm, amount: e.target.value })}
              style={{ padding: '10px 12px' }}
            />
          </div>

          {/* Payment Type */}
          <div>
            <label style={{ fontWeight: 600, marginBottom: '6px', display: 'block' }}>Payment Type *</label>
            <select 
              className="form-control" 
              value={advanceForm.payment_type}
              onChange={(e) => setAdvanceForm({ ...advanceForm, payment_type: e.target.value })}
              style={{ padding: '10px 12px' }}
            >
              {paymentTypes.map((t, i) => (
                <option key={i} value={t}>{t}</option>
              ))}
            </select>
          </div>

        {/* Received By - Read-only */}
<div>
  <label style={{ fontWeight: 600, marginBottom: '6px', display: 'block' }}>Received By *</label>
  <input 
    type="text" 
    className="form-control" 
    value={advanceForm.received_by} 
    readOnly
    disabled
    style={{ 
      padding: '10px 12px', 
      backgroundColor: '#e9ecef',
      cursor: 'not-allowed'
    }}
  />
</div>
        </div>

        {/* Save Button */}
        <div style={{ marginBottom: '25px' }}>
          <button 
            className="btn btn-primary" 
            onClick={saveAdvance}
            style={{ padding: '10px 30px' }}
          >
            <i className="ri-save-line me-1"></i> Save Advance
          </button>
        </div>

        {/* Transaction History */}
        <div>
          <h6 style={{ color: '#405189', marginBottom: '12px', fontWeight: 600 }}>
            <i className="ri-history-line me-1"></i> Payment Transaction History
          </h6>

          {advanceHistory.length === 0 ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '30px', 
              background: '#f8f9fa', 
              borderRadius: '8px' 
            }}>
              <i className="ri-file-list-3-line" style={{ fontSize: '40px', color: '#ccc' }}></i>
              <p style={{ marginTop: '10px', color: '#666' }}>No advance payments found</p>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f1f5fb' }}>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #ddd', color: '#405189' }}>SL</th>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #ddd', color: '#405189' }}>Date</th>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #ddd', color: '#405189' }}>Amount</th>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #ddd', color: '#405189' }}>Payment Type</th>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #ddd', color: '#405189' }}>Received By</th>
                  
                  <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #ddd', color: '#405189' }}>Action</th>
                
                </tr>
              </thead>
              <tbody>
                {advanceHistory.map((item, index) => (
                  <tr key={item.advance_id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '10px' }}>{index + 1}</td>
                    <td style={{ padding: '10px' }}>
                      {new Date(item.payment_date).toLocaleDateString('en-IN', { 
                        day: '2-digit', 
                        month: 'short', 
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </td>
                    <td style={{ padding: '10px', fontWeight: 600, color: '#198754' }}>
                      ₹ {parseFloat(item.advance_amount).toFixed(2)}
                    </td>
                    <td style={{ padding: '10px' }}>
                      <span style={{
                        background: item.payment_type === 'Cash' ? '#e8f5e9' : 
                                   item.payment_type === 'Card' ? '#e3f2fd' :
                                   item.payment_type === 'UPI' ? '#fff3e0' : '#f3e5f5',
                        padding: '4px 12px',
                        borderRadius: '15px',
                        fontSize: '12px',
                        fontWeight: 500
                      }}>
                        {item.payment_type}
                      </span>
                    </td>
                    <td style={{ padding: '10px' }}>{item.received_by}</td>

                    <td style={{ padding: '10px', textAlign: 'center', whiteSpace: 'nowrap' }}>
  {/* PRINT */}
  <button
    className="btn btn-sm btn-outline-primary me-1"
    title="Print Receipt"
    onClick={() => printSingleAdvanceReceipt(item)}
  >
    <i className="ri-printer-line"></i>
  </button>
  
                      <button 
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => deleteAdvance(item.advance_id)}
                        style={{ padding: '4px 10px' }}
                      >
                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

      </div>
    </div>
  </div>
)}



{showOrderTreatmentModal && orderTreatmentPatient && (
  <OrderTreatmentModal
    show={showOrderTreatmentModal}
    onClose={() => {
      setShowOrderTreatmentModal(false);
      setOrderTreatmentPatient(null);
    }}
    patient={orderTreatmentPatient}
    headerLogo={headerLogo}
    userType={getUserType()}
    currentUser={getStoredUser()}
    doctors={formData.docs || []}
  />
)}
    </div>
  );
};

export default IpdPataintList;
